module.exports = __webpack_public_path__ + "static/media/Sponsored Ad Performance.86b6b2a1.svg";